<mat-toolbar class="footer-toolbar">
  <div class="footer-toolbar__inner">
    <div *ngIf="!isSmallScreen" class="footer-toolbar__center">
      <!--TODO: A GARDER COMMENTER. NE PAS EFFACER-->
      <div
        *ngxPermissionsOnly="['GOD']"
        class="footer-toolbar__god-api"
        style="
          cursor: pointer;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: start;
        "
      >
        <div
          *ngIf="api.isLocal"
          class="flex-row"
          [matMenuTriggerFor]="switcherReceipt"
          style="cursor: pointer; font-size: 13px"
        >
          <span class="copyright">API: &nbsp;</span>
          <div
            [ngStyle]="{
              color: api.localAPITarget === 'DEV' ? 'tomato' : 'chartreuse',
            }"
          >
            <span class="copyright">{{ api.localAPITarget }}</span>
          </div>
        </div>

        <mat-menu #switcherReceipt="matMenu">
          <!-- <button
              *ngIf="api.isLocal"
              mat-menu-item
              (click)="onSwitchLocalAPI('LOCAL')"
            >
              Local
            </button>
            <button mat-menu-item (click)="onSwitchLocalAPI('DEV')">Dev</button>
            <button mat-menu-item (click)="onSwitchLocalAPI('DEV2')">
              Dev 2
            </button> -->
        </mat-menu>
      </div>
    </div>

    <div class="footer-toolbar__right">
      <div class="footer-status-row">
        <ng-container *ngxPermissionsOnly="['GOD']">
          <div
            class="footer-status-item footer-connection footer-connection--clickable"
            (click)="onShowFirebaseStatus()"
            aria-label="Connection"
          >
            <mat-icon
              *ngIf="firebaseConnected"
              class="footer-connection__dot footer-connection__dot--on"
              >brightness_1</mat-icon
            >
            <mat-icon
              *ngIf="!firebaseConnected"
              class="footer-connection__dot footer-connection__dot--off"
              >brightness_1</mat-icon
            >
          </div>

          <button
            mat-icon-button
            type="button"
            (click)="onOpenAPICallBenching()"
            class="footer-status-item footer-clock-btn"
            aria-label="API benching"
          >
            <mat-icon class="icon-mat">access_time</mat-icon>
          </button>

          <span class="copyright footer-status-item footer-timezone">
            {{ timezone }}
          </span>
        </ng-container>

        <span
          class="copyright footer-status-item footer-version footer-version--clickable"
          role="button"
          tabindex="0"
          (click)="onForceUpdate()"
          (keydown.enter)="onForceUpdate()"
          matTooltip="{{ 'APP_UPDATE.TOOLTIP' | translate }}"
        >
          {{ environment.appVersion }}
        </span>
      </div>
    </div>
  </div>
</mat-toolbar>

<ng-template #firebaseDialogTemplate let-item>
  <div class="gt2-order-theme flex-row-start-center">
    <h1>Firebase: {{ firebaseConnected ? "connecté" : "déconnecté" }}</h1>
    <mat-icon
      style="margin-left: 5px; margin-top: 3px; color: #009688"
      *ngIf="firebaseConnected"
      >brightness_1</mat-icon
    >
    <mat-icon
      style="margin-left: 5px; margin-top: 3px"
      *ngIf="!firebaseConnected"
      color="warn"
      >block</mat-icon
    >
  </div>

  <h3 style="margin-top: 12px">Auth State</h3>
  <div class="firebase-item">
    <b>Firebase UID:</b> &nbsp;
    <span [style.color]="firebaseUid ? 'green' : 'red'">{{
      firebaseUid || "non authentifié"
    }}</span>
  </div>
  <div class="firebase-item">
    <b>firebase_token in localStorage:</b> &nbsp;
    <span [style.color]="firebaseTokenPresent ? 'green' : 'red'">{{
      firebaseTokenPresent ? "oui" : "non"
    }}</span>
  </div>
  <div class="firebase-item">
    <b>Subscription Status:</b> &nbsp;
    <span
      [style.color]="firebaseSubscriptionStatus === 'active' ? 'green' : 'red'"
      >{{ firebaseSubscriptionStatus }}</span
    >
  </div>
  <div class="firebase-item" *ngIf="firebaseSubscriptionError">
    <b>Subscription Error:</b> &nbsp;
    <span style="color: red">{{ firebaseSubscriptionError }}</span>
  </div>

  <h3 style="margin-top: 12px">Listening Nodes</h3>
  <div class="firebase-item">
    <b>tenant.slug:</b> &nbsp;{{ firebaseTenantSlug || "N/A" }}
  </div>
  <div class="firebase-item">
    <b>user.uuid:</b> &nbsp;{{ firebaseUserUuid || "N/A" }}
  </div>
  <div class="firebase-item" style="word-break: break-all">
    <b>Processes:</b> &nbsp;
    <span *ngIf="firebaseProcessPath">
      <span [style.color]="firebaseConnected ? 'green' : 'orange'"
        >{{ environment.firebase.databaseURL }}/{{ firebaseProcessPath }}</span
      >
      <span *ngIf="!firebaseConnected" style="color: red">
        (not listening)</span
      >
    </span>
    <span *ngIf="!firebaseProcessPath" style="color: red"
      >not listening <br /><small style="color: grey"
        >Expected: {{ environment.firebase.databaseURL }}/{{
          environment.firebaseEnvironment
        }}/{{ firebaseTenantSlug || "{tenant.slug}" }}/{{
          firebaseUserUuid || "{user.uuid}"
        }}/processes</small
      >
    </span>
  </div>

  <h3 style="margin-top: 12px">Config</h3>
  <div class="firebase-item">
    <b>Environment:</b> &nbsp;{{ environment.firebaseEnvironment }}
  </div>
  <div class="firebase-item">
    <b>databaseURL:</b> &nbsp;{{ environment.firebase.databaseURL }}
  </div>
  <div class="firebase-item">
    <b>projectId:</b> &nbsp;{{ environment.firebase.projectId }}
  </div>

  <div class="flex-row-center-center">
    <button
      mat-raised-button
      color="primary"
      (click)="dialogRef.close(false)"
      style="margin-top: 18px"
      class=""
    >
      {{ "GENERIC.OK" | translate }}
    </button>
  </div>
</ng-template>
